<template>
  <div class="content">
    <div class="container-fluid" v-if="metrics">
      <!-- Niños -->
      <div class="row">
        <div class="col-xl-4 col-md-12">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-users text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.qty_kids }}</h4>
            </div>
            <div slot="footer">
              Registrados
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-male text-info"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.boys }}</h4>
            </div>
            <div slot="footer">
              Niños
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-female text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.girls }}</h4>
            </div>
            <div slot="footer">
              Niñas
            </div>
          </stats-card>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <chart-card :chart-data="lineChart.data"
                      :chart-options="lineChart.options"
                      :responsive-options="lineChart.responsiveOptions"
                      chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Registrados por género</h4>
              <p class="card-category">Divididos por edad</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Niños
                <i class="fa fa-circle text-danger"></i> Niñas
              </div>
            </template>
          </chart-card>
        </div>

        <div class="col-md-8">
          
          <card class="row table-y-responsive">
            <l-table class="table table-hover table-striped" :columns="tableKids.columns" :data="tableKids.data">
                <template slot-scope="{row}">
                  <td>{{ row.id }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.kids }}</td>
                  <td>{{ row.girls }}</td>
                  <td>{{ (parseInt(row.girls) + parseInt(row.kids)) }}</td>
                </template>
              </l-table>
          </card>

        </div>

        <div class="col-md-4">
          <chart-card :chart-data="pieChart.data" chart-type="Pie">
            <template slot="header">
              <h4 class="card-title">% de Registrados</h4>
              <p class="card-category">Niños/Niñas</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Niños
                <i class="fa fa-circle text-danger"></i> Niñas
              </div>
            </template>
          </chart-card>
        </div>
      </div>

      <!-- Visitas -->
      <div class="row">
        <div class="col-12">
          <card class="row">
            <div class="col-12">
              <h3>Visitas</h3>
            </div>
            <div class="col-12 table-y-responsive">
              <l-table class="table table-hover table-striped" :columns="tableVisits.columns" :data="tableVisits.data">
                <template slot-scope="{row}">
                  <td>{{ row.country }}</td>
                  <td>{{ row.city }}</td>
                  <td>{{ row.qty_boys }}</td>
                  <td>{{ row.qty_girls }}</td>
                  <td>{{ (parseInt(row.qty_girls) + parseInt(row.qty_boys)) }}</td>
                </template>
              </l-table>
            </div>
          </card>
        </div>
      </div>
      <!-- / Visitas -->

      <!-- / Niños -->

      <!-- Correos -->
      <div class="row">
        <div class="col-xl-4 col-md-12">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-envelope-o text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.qty_emails }}</h4>
            </div>
            <div slot="footer">
              Correos
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-male text-info"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.qty_boys_emails }}</h4>
            </div>
            <div slot="footer">
              Correos Niños
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-female text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.qty_girls_emails }}</h4>
            </div>
            <div slot="footer">
              Correos Niñas
            </div>
          </stats-card>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <chart-card :chart-data="lineChartEmail.data"
                      :chart-options="lineChartEmail.options"
                      :responsive-options="lineChartEmail.responsiveOptions"
                      chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Correos por género</h4>
              <p class="card-category">Divididos por tema</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Niños
                <i class="fa fa-circle text-danger"></i> Niñas
              </div>
            </template>
          </chart-card>
        </div>

        <div class="col-md-8">
          
          <card class="row table-y-responsive">
            <l-table class="table table-hover table-striped" :columns="tableEmails.columns" :data="tableEmails.data">
                <template slot-scope="{row}">
                  <td>{{ row.id }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.kids }}</td>
                  <td>{{ row.girls }}</td>
                  <td>{{ (parseInt(row.girls) + parseInt(row.kids)) }}</td>
                </template>
              </l-table>
          </card>

        </div>

        <div class="col-md-4">
          <chart-card :chart-data="pieChartEmail.data" chart-type="Pie">
            <template slot="header">
              <h4 class="card-title">% de Correos</h4>
              <p class="card-category">Niños/Niñas</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Niños
                <i class="fa fa-circle text-danger"></i> Niñas
              </div>
            </template>
          </chart-card>
        </div>
      </div>
      <!-- / Correos -->

      <!-- Videos -->
      <div class="row">
        <div class="col-xl-4 col-md-12">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-play text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.qty_videos }}</h4>
            </div>
            <div slot="footer">
              Videos
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-male text-info"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.qty_boys_videos }}</h4>
            </div>
            <div slot="footer">
              Videos Niños
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="fa fa-female text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total</p>
              <h4 class="card-title">{{ metrics.qty_girls_videos }}</h4>
            </div>
            <div slot="footer">
              Videos Niñas
            </div>
          </stats-card>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <chart-card :chart-data="lineChartVideos.data"
                      :chart-options="lineChartVideos.options"
                      :responsive-options="lineChartVideos.responsiveOptions"
                      chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Videos por género</h4>
              <p class="card-category">Divididos por tema</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Niños
                <i class="fa fa-circle text-danger"></i> Niñas
              </div>
            </template>
          </chart-card>
        </div>

        <div class="col-md-8">
          
          <card class="row table-y-responsive">
            <l-table class="table table-hover table-striped" :columns="tableVideos.columns" :data="tableVideos.data">
                <template slot-scope="{row, index}">
                  <td>{{ row.id }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.kids }}</td>
                  <td>{{ row.girls }}</td>
                  <td>{{ (parseInt(row.girls) + parseInt(row.kids)) }}</td>
                </template>
              </l-table>
          </card>

        </div>

        <div class="col-md-4">
          <chart-card :chart-data="pieChartVideo.data" chart-type="Pie">
            <template slot="header">
              <h4 class="card-title">% de Videos</h4>
              <p class="card-category">Niños/Niñas</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Niños
                <i class="fa fa-circle text-danger"></i> Niñas
              </div>
            </template>
          </chart-card>
        </div>
      </div>

      <!-- / Videos -->

    </div>

    <div class="container-fluid" v-else>
      <div class="row b-flex b-flex justify-content-center" style="height: 100%;">
        <card class="b-flex justify-content-center align-self-center pt-4 p-2">
          <p class="text-center">
            <i class="text-info fa fa-circle-o fa-spin fa-5x"></i>
          </p>
          <h2 class="text-center">
            Cargando...
          </h2>
        </card>
      </div>
    </div>

  </div>
</template>

<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'

  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    async mounted () {
      this.$http.get('metrics')
        .then(res => {
          console.log('Metrics', res.data)
          this.metrics = res.data

          // let labels = res.data.kids_by_age.map(e => e.age === '0' ? 'Menores de 1 año' : (e.age + ' año' + (e.age === 1 ? '' : 's')))
          let labels = res.data.kids_by_age.map((e, i) => (i + 1))
          console.log('Labels', labels)

          this.lineChart.data.labels = labels
          this.lineChart.data.series[0] = res.data.kids_by_age.map(e => e.qty_boys)
          this.lineChart.data.series[1] = res.data.kids_by_age.map(e => e.qty_girls)
          this.lineChart.options.high = res.data.max_total_kids

          this.pieChart.data.labels = [
            ((res.data.boys * 100) / res.data.qty_kids).toFixed(2) + '%',
            ((res.data.girls * 100) / res.data.qty_kids).toFixed(2) + '%'
          ]

          this.pieChart.data.series = [
            ((res.data.boys * 100) / res.data.qty_kids),
            ((res.data.girls * 100) / res.data.qty_kids)
          ]

          this.pieChartEmail.data.labels = [
            ((res.data.qty_boys_emails * 100) / res.data.qty_emails).toFixed(2) + '%',
            ((res.data.qty_girls_emails * 100) / res.data.qty_emails).toFixed(2) + '%'
          ]

          this.pieChartEmail.data.series = [
            ((res.data.qty_boys_emails * 100) / res.data.qty_emails),
            ((res.data.qty_girls_emails * 100) / res.data.qty_emails)
          ]

          this.pieChartVideo.data.labels = [
            ((res.data.qty_boys_videos * 100) / res.data.qty_videos).toFixed(2) + '%',
            ((res.data.qty_girls_videos * 100) / res.data.qty_videos).toFixed(2) + '%'
          ]

          this.pieChartVideo.data.series = [
            ((res.data.qty_boys_videos * 100) / res.data.qty_videos),
            ((res.data.qty_girls_videos * 100) / res.data.qty_videos)
          ]

          this.lineChartEmail.options.high = res.data.qty_boys_emails === res.data.qty_girls_emails ? res.data.qty_girls_emails : (res.data.qty_boys_emails > res.data.qty_girls_emails ? res.data.qty_boys_emails : res.data.qty_girls_emails)

          this.lineChartVideos.options.high = res.data.qty_boys_videos === res.data.qty_girls_videos ? res.data.qty_girls_videos : (res.data.qty_boys_videos > res.data.qty_girls_videos ? res.data.qty_boys_videos : res.data.qty_girls_videos)

          this.lineChartEmail.data.labels = res.data.email_by_kids.map((e, i) => (i + 1))
          this.lineChartEmail.data.series[0] = res.data.email_by_kids.map(e => e.qty_boys)
          this.lineChartEmail.data.series[1] = res.data.email_by_kids.map(e => e.qty_girls)

          this.lineChartVideos.data.labels = res.data.videos_by_kids.map((e, i) => (i + 1))
          this.lineChartVideos.data.series[0] = res.data.videos_by_kids.map(e => e.qty_boys)
          this.lineChartVideos.data.series[1] = res.data.videos_by_kids.map(e => e.qty_girls)

          this.tableKids.data = res.data.kids_by_age.map((e, i) => {
            return {
              id: (i + 1),
              name: (e.age === '0' ? 'Menores de 1 año' : (e.age + ' año' + (e.age === 1 ? '' : 's'))),
              kids: e.qty_boys,
              girls: e.qty_girls
            }
          })

          this.tableVisits.data = res.data.kids_by_location
          this.tableEmails.data = res.data.email_by_kids.map((e, i) => {
            return {
              id: (i + 1),
              name: e.name,
              kids: e.qty_boys,
              girls: e.qty_girls
            }
          })

          this.tableVideos.data = res.data.videos_by_kids.map((e, i) => {
            return {
              id: (i + 1),
              name: e.name,
              kids: e.qty_boys,
              girls: e.qty_girls
            }
          })
        })
    },
    data () {
      return {
        metrics: null,
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        pieChart: {
          data: {
            labels: [],
            series: []
          }
        },
        pieChartEmail: {
          data: {
            labels: [],
            series: []
          }
        },
        pieChartVideo: {
          data: {
            labels: [],
            series: []
          }
        },
        lineChart: {
          data: {
            labels: [],
            series: [
            ]
          },
          options: {
            low: 0,
            high: 18,
            showArea: false,
            height: '260px',
            axisX: {
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          }
        },
        lineChartEmail: {
          data: {
            labels: [],
            series: [
            ]
          },
          options: {
            low: 0,
            high: 18,
            showArea: false,
            height: '260px',
            axisX: {
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          }
        },
        lineChartVideos: {
          data: {
            labels: [],
            series: [
            ]
          },
          options: {
            low: 0,
            high: 18,
            showArea: false,
            height: '260px',
            axisX: {
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          }
        },
        tableKids: {
          columns: ['#', 'Edad', 'Niños', 'Niñas', 'Total'],
          data: []
        },
        tableVisits: {
          columns: ['País', 'Ciudad', 'Niños', 'Niñas', 'Total'],
          data: []
        },
        tableEmails: {
          columns: ['#', 'Tema', 'Niños', 'Niñas', 'Total'],
          data: []
        },
        tableVideos: {
          columns: ['#', 'Tema', 'Niños', 'Niñas', 'Total'],
          data: []
        }
      }
    }
  }
</script>
<style lang="scss">
  .table-y-responsive {
    overflow-y: auto;
    height: 450px;
    max-height: 450px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Overview.vue